/** The cookie that remembers whether the narrowing filters are shown as dropdowns or checkboxes. */
export const displayFiltersAsDropdownCookieKey = 'advancedSearch:displayFiltersAsDropdown';
